{
    "NavigationAll": "Tutti",
    "NavigationReporting": "Segnalazione",
    "NavigationAdministration": "Amministrazione",
    "NavigationProvisioning": "Approvvigionamento",
    "NavigationDevices": "Dispositivi",
    "NavigationEndpoints": "Punti finali",
    "NavigationTrunking": "Trunking",
    "NavigationHospitality": "Ospitalità",
    "NavigationTrunkgateways": "Gateway di tronco",
    "NavigationVoicemailservices": "Servizi di posta vocale",
    "NavigationConferencedevices": "Dispositivi per conferenze",
    "NavigationAgents": "Agenti",
    "NavigationDirectory": "Elenco",
    "NavigationCodes": "Codici",
    "NavigationPartitions": "Divisori",
    "NavigationTelephonyservers": "Server di telefonia",
    "NavigationCmenvironments": "Ambienti di gestione centrale",
    "NavigationApplicationusers": "Utenti dell'applicazione",
    "NavigationOmnichannel": "Omnichannel",
    "NavigationRecording": "Registrazione",
    "NavigationMessages": "Messaggi",
    "NavigationDatabase": "Database",
    "NavigationStatustools": "Stato e strumenti",
    "NavigationLicenses": "Licenze",
    "NavigationLogging": "Registrazione",
    "NavigationLogmanagement": "Gestione dei registri",
    "NavigationAudittrail": "Traccia di controllo",
    "NavigationTelephonemodulestatus": "Stato del modulo telefonico",
    "NavigationOmnichannelmodulestatus": "Stato dell'Omnichannel",
    "NavigationCallcontrol": "Controllo chiamate",
    "NavigationServerstatus": "Stato del server",
    "NavigationNewAnalytics": "Aggiungi azienda aziendale",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Approfondimenti",
    "Presence": "Presenza",
    "NavigationUserManagement": "Gestione degli utenti",
    "NavigationManageUsersDevice": "Gestisci utenti",
    "NavigationEasyProvisioning": "Facile provisioning",
    "NavigationManageQueues": "Gestisci code"
}